import React from 'react';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';

const CustomIcon = styled('span')(({ theme }) => ({
  borderRadius: '50%',
  minWidth: 20,
  minHeight: 20,
  boxShadow: 'inset 0 0 0 1px #8D929C',
  backgroundColor: '#fff',
  display: 'inline-block',
}));

const CustomCheckedIcon = styled(CustomIcon)(() => ({
  boxShadow: 'inset 0 0 0 1px #1A77F2',
  position: 'relative',
  '&::after': {
    content: '""',
    display: 'block',
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: '#1A77F2',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
}));


const RadioButton = ({
  id,
  radioname,
  title,
  checked,
  classes = '',
  action = () => {},
  value,
  radioSize = '20px',
  fontSize = '13px',
  marginLeft = '5px',
  fontWeight = '400',
  color = '#111828',
  padding,
  borderWidth = '1px',
  customRadio = false,
}) => (
  <div className={`custom_radio_group ${classes}`}>
    <FormControlLabel
      id={id}
      value={id}
      name={radioname}
      control={
        <Radio
          sx={{
            p: padding,
            '& .MuiSvgIcon-root': {
              fontSize: radioSize,
              borderWidth,
            },
          }}
          icon={customRadio ? <CustomIcon /> : undefined}
          checkedIcon={customRadio ? <CustomCheckedIcon /> : undefined}
        />
      }
      label={title}
      checked={checked}
      size="small"
      onChange={action}
      sx={{
        '& .MuiFormControlLabel-label': {
          fontSize,
          fontWeight,
          whiteSpace: 'nowrap',
          marginLeft,
          marginRight: '0px',
          color: `${color} !important`,
        },
      }}
    />
  </div>
);

export default RadioButton;
